import { gql, useQuery, WatchQueryFetchPolicy } from '@apollo/client'
import { useMemo } from 'react'

const CUSTOMER_COUPONS_QUERY = gql`
  query CustomerCoupons {
    customerCoupons {
      id
      code
      qrCode
      name
      status
      validFrom
      validTo
      localInfo {
        id
        title
        description
        canBeActivated
        validFrom
        validTo
        image {
          url
        }
      }
    }
  }
`

export type CouponInfo = {
  id: string;
  code?: string;
  qrCode?: string;
  name?: string;
  status?: string;
  validFrom?: number;
  validTo?: number;
  localInfo?: {
    id: string;
    title?: string;
    description?: string;
    canBeActivated?: boolean;
    validFrom?: number;
    validTo?: number;
    image?: {
      url?: string;
    };
  };
}

type CustomerCouponsQueryType = {
  customerCoupons: CouponInfo[];
}

interface UseCouponsParams {
  skip?: boolean;
  fetchPolicy?: WatchQueryFetchPolicy;
}

export function useCoupons ({
  skip = false,
  fetchPolicy = 'cache-and-network'
}: UseCouponsParams = {}) {
  const { data, loading, error, refetch } = useQuery<CustomerCouponsQueryType>(CUSTOMER_COUPONS_QUERY, {
    fetchPolicy,
    skip,
  })

  const coupons = useMemo(() => {
    if (!data?.customerCoupons) return []
    return data.customerCoupons.filter((coupon): coupon is CouponInfo => coupon !== null)
  }, [ data ])

  return {
    coupons,
    loading,
    error,
    refetch,
  }
}
